import { Outlet } from 'react-router-dom';
import { AppTopHeader } from './AppTopHeader';
import styles from './AppShell.module.scss';

// Basic app shell: a top bar + the routed page.
export const AppShell = () => {
  return (
    <div className={styles.shell}>
      <AppTopHeader />
      <main className={styles.content}>
        <Outlet />
      </main>
    </div>
  );
};
